//Badge award images live under /files/badges/ (same URLs as GET /badges).
export function isAchievementBadgeImageUrl(url: string | undefined | null): boolean {
  if (!url?.trim()) return false;

  try {
    const pathname = new URL(url, process.env.REACT_APP_BASE_URL)
      .pathname.replace(/^\/api(?=\/)/, "");
    return pathname.includes("/files/badges/");
  } catch {
    return /\/files\/badges\//i.test(url);
  }
}
